import { Helmet } from 'react-helmet-async';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { useState } from "react";


const Background = () => {
    const [activeTab, setActiveTab] = useState("tab1");
    return (
        <div className='about-mijsc-section w-full bg-cover h-fit pb-5'>
            <Helmet>
                <title>About  | Background </title>
                <meta name="description" content="Learn more about MIJSC, our mission, vision, and commitment to excellence." />
            </Helmet>
            <BreadCrumbs />

            <div className=' w-[96%] text-justify mx-3'>
                <section className='w-full h-fit md:mx-2 px-3 mb-5 ' >
                    <h1 className='md:text-4xl text-lg py-3 text-green-600 font-semibold pt-10'>IIMB : Academic Hub</h1>
                    <h2 className='md:text-xl font-semibold border-b pb-1 mt-1'>Where Classroom Learning Meets India's Corporate Capital</h2>
                    <ul className="list-disc list-inside mt-8">
                        <li className="text-gray-600 text-md my-4">Indian Institute of Management Bangalore (IIMB) offers a diverse portfolio of long-duration programmes including PhD, PGP, PGP-BA, EPGP, and PGPEM, along with nationally impactful certificate programmes such as the NS Ramaswamy Pre-Doctoral Fellowship and the Mahatma Gandhi National Fellowship in Public Policy and Management. </li>
                        <li className="text-gray-600 text-md my-4">With 11 academic disciplines and 10 Centres of Excellence, IIMB actively engages with industry and policy through partnerships with Goldman Sachs, Kotak Bank, NITI Aayog, and the Michael & Susan Dell Foundation, driving entrepreneurship, inclusion, and social impact. </li>
                        <li className="text-gray-600 text-md my-4">A pioneer in technology-enabled education, IIMB was the first Indian management school to offer MOOCs on edX and serves as the coordinating institute for management education on SWAYAM. Accredited by EQUIS for the highest five-year term, IIMB maintains a strong global footprint through international exchanges and the Global Network for Advanced Management (GNAM), connecting with 32 leading business schools worldwide. </li>
                    </ul>
                    <div className="w-full my-6 pt-3">
                        <video
                            className="md:w-[70%] w-full rounded-lg shadow-lg place-self-center"
                            controls
                            autoPlay
                            muted
                            loop
                        >
                            <source src="/iimb-vdo-2026.mp4" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>






                </section>

            </div>

        </div>
    )
}

export default Background
